import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextBody, TextParagraph } from '../../atoms';
export function PaginationRange({ perPage, totalCount }) {
    return (_jsxs(TextParagraph, { children: [_jsx(TextBody, { color: "primary", children: "Showing " }), _jsxs(TextBody, { em: true, children: [totalCount < perPage ? totalCount : perPage, " "] }), _jsx(TextBody, { color: "primary", children: "of " }), _jsx(TextBody, { em: true, children: totalCount })] }));
}
